<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">

				<!-- <el-row>
					<el-col :span="24">
						<el-form-item label="Sprint" prop="header">
							<el-select v-model="spidx" @change="chgSprint" placeholder="规则是先创建Sprint再创建team">
								<el-option v-for="(v, i) in sprintList" :key="i" :value="i" :label="v.spname">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row> -->

				<el-row>
					<el-col :span="24">
						<el-form-item label="Sprint:" prop="snm" style="font-weight: bold;"
							v-if="parameter.snm != null">
							{{ parameter.snm }}
						</el-form-item>
						<el-form-item label="Sprint:" prop="snm" style="color:#0099FF ;"
							v-else-if="parameter.snm == null">
							未分配<b>Sprint</b>，请到<b>Sprint</b>列表选择<b>Sprint</b>添加该团队
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="团队名称:" prop="name">
							{{ formParameter.name }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="负责人:" prop="header">
							{{ formParameter.header }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="parameter.pname">
					<el-col :span="24">
						<el-form-item label="产品名称:" prop="header">
							【{{ parameter.pname }}】
							<span v-if="parameter.sprints" v-for="(v, i) in parameter.sprints">{{ v.nm }} <span
									v-if="i < (parameter.sprints.length - 1)">、</span> </span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-button size="mini" v-has-permission-code-and="'003000050005'" @click="toAddMember"
							type="warning">添加成员</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-table :data="teamMember" style="width: 100%;">
							<el-table-column prop="did" label="所在部门" width="150">
								<template slot-scope="scope">
									<!-- scope.row.did -->
									<el-select :disabled="scope.row.post == 'PO'" v-model="scope.row.did"
										@change="chgDeptArres($event, scope.$index)" placeholder="请选择">
										<el-option v-for="(item, idx) in deptArres" :key="idx" :label="item.name"
											:value="idx">
										</el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column prop="post" label="角色" width="110">
								<template slot-scope="scope">
									<select-option-dictionary
										:disabled="scope.row.post == 'PO' || select2Use[scope.$index]"
										v-model="scope.row.post" dkey="scrum-roles2"></select-option-dictionary>
								</template>
							</el-table-column>
							<el-table-column prop="username" label="名字" width="130">
								<template slot-scope="scope">
									<!-- scope.row.uid -->
									<el-select :disabled="scope.row.post == 'PO' || select3Use[scope.$index]"
										v-model="scope.row.uid" @change="chgEmpArres($event, scope.$index)"
										placeholder="请选择">
										<el-option v-for="(itm, index) in empArres[scope.$index]" :key="index"
											:label="itm.name" :value="index">
										</el-option>
									</el-select>
								</template>
							</el-table-column>

							<el-table-column prop="starttime" label="开始时间">
								<template slot-scope="scope">
									<el-date-picker :disabled="scope.row.post == 'PO'" v-model="scope.row.starttime"
										type="date" @change="chgTime(1, scope.row)" placeholder="选择日期">
									</el-date-picker>
								</template>
							</el-table-column>
							<el-table-column prop="endtime" label="结束时间">
								<template slot-scope="scope">
									<el-date-picker :disabled="scope.row.post == 'PO'" v-model="scope.row.endtime"
										type="date" @change="chgTime(2, scope.row)" placeholder="选择日期">
									</el-date-picker>
								</template>
							</el-table-column>

							<el-table-column prop="hour4day" label="工时" width="85">
								<template slot-scope="scope">
									<el-input v-model="scope.row.hour4day"
										@blur="checkMemberTime(scope.row, scope.$index)" autocomplete="off"></el-input>
								</template>
							</el-table-column>

							<el-table-column prop="mobile" label="信息" width="180">
								<template slot-scope="scope">
									性别：{{ scope.row.sex }}<br />
									电话：{{ scope.row.mobile }}
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope">
									<el-button v-show="scope.row.post != 'PO'" size="mini" type="danger"
										v-has-permission-code-and="'003000050005'"
										@click="delteamMember(scope.$index, scope.row)">删除</el-button>
								</template>
							</el-table-column>

						</el-table>
					</el-col>

				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-has-permission-code-and="'003000050005'" v-if="!disabled" type="primary"
				:loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/team/team/team.js';
import spApi from '@/api/sprint/sprint/sprint.js';
import apiDpt from '@/api/system/department/department.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';


export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
	},
	data() {
		return {

			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {}, //主页面传过来的数据

			formParameter: {},  //team
			teamMember: [],	     //team成员  [{},{}..]

			deptArres: [],       //备选的部门  [{},{}..]
			empArres: [],        //备选的员工  [[{},{}..],[]..]  2维数组


			postArres: [],		 //备选职位
			postBackup: [],		//职位备份，当删除sm时还原到备选职位
			select2Use: [],      //只能按照顺序选择
			select3Use: [],      //只能按照顺序选择

			sprintList: [],//备选的Sprints
			spidx: '',      //选中的Sprints 序号

			tid: false,
			sprint: '',
			isAdd: true,   //是不是添加页面？编辑页面

			saveTeamParam: {
				teamInfo: {},
				teamMembers: [],
			},
			updateTeamParam: {
				teamInfo: {},
				teamMembers: [],
				id: "",
			},
			delMember: {},

			rules: {
				//团队名称
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 40,
						trigger: 'blur'
					}
				],

				//开始时间
				starttime: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				//结束时间
				endtime: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],

			}
		};
	},
	methods: {
		chgTime(type, row) {

			if (!row.starttime) {
				this.$utils.msg.warning("输入开始时间不能为空");
				row.starttime = new Date(this.sprint.stm)
				return false
			}
			if (!row.endtime) {
				this.$utils.msg.warning("输入结束时间不能为空");
				row.endtime = new Date(this.sprint.etm)
				return false
			}

			if (typeof (row.starttime) == "string") {
				row.starttime = new Date(new Date(row.starttime).getTime() - 28800000)
			}

			if (typeof (row.endtime) == "string") {
				row.endtime = new Date(new Date(row.endtime).getTime() - 28800000)
			}

			let this_stm = row.starttime.getTime()
			let this_etm = row.endtime.getTime()
			let sprint_stm = new Date(this.sprint.stm).getTime() - 28800000
			let sprint_etm = new Date(this.sprint.etm).getTime() - 28800000


			if (this_stm - this_etm > 0) {
				this.$utils.msg.warning("输入开始时间不能大于结束时间");
				row.starttime = new Date(this.sprint.stm)
				row.endtime = new Date(this.sprint.etm)
				return false
			}

			if (type == 1) {  //开始时间
				if (this_etm != this_stm && (this_stm < sprint_stm || this_stm > sprint_etm)) {
					this.$utils.msg.warning("输入开始时间错误");
					//重置
					row.starttime = new Date(this.sprint.stm)
				}
			} else {

				if (this_etm != this_stm && (this_etm < sprint_stm || this_etm > sprint_etm)) {
					this.$utils.msg.warning("输入结束时间错误");
					//重置
					row.endtime = new Date(this.sprint.etm)
				}
			}
		},

		//下拉部门列表
		//		idx2下拉表单中的行，idx列表的第几行
		chgDeptArres(idx2, idx) {

			let dpt = this.deptArres[idx2]

			//取回员工                     为保证请求参数不一样
			//根据部门名字获取员工信息
			apiDpt.deptEmps({ did: dpt.id, idx: idx }, res => {
				//备选的员工 [[{},{}..],[],[]..]
				this.empArres[idx] = res.data
				let repeatEmps = []
				//此人是否已存在
				this.empArres[idx].forEach((v, i) => {
					for (let index = 0; index < this.teamMember.length; index++) {
						//排除之前已加过
						if (v.name == this.teamMember[index].uid) {
							repeatEmps.push(i)
						}
					}
				})
				//如果存在重复
				if (repeatEmps.length > 0) {
					for (let rptIdx = 0; rptIdx < repeatEmps.length; rptIdx++) {
						const pos = repeatEmps[rptIdx];
						//相对位置  删除一个
						this.empArres[idx].splice(pos - rptIdx, 1)
					}
				}

				let postTmp = this.teamMember[idx].post
				//强制刷新
				this.$set(this.teamMember[idx], 'post', null)
				setTimeout(() => {
					this.$set(this.teamMember[idx], 'post', postTmp)
				}, 10)


			})

		}, checkMemberTime(row, idx) {

			if (row.hour4day * 1 <= 0 || row.hour4day * 1 > 8) {
				this.$utils.msg.warning("输入值错误");
				row.hour4day = ""
				return false;
			}
			api.checkMemberTime2({
				id: row.id,
				mobile: row.mobile,
				starttime: row.starttime,
				endtime: row.endtime,
				hour4day: (row.hour4day ? row.hour4day : 0)
			}, res => {
				// do nothing!
			}, err => {
				let maxHours = 8 - err.msg * 1;
				this.$utils.confirm.warning('提示,配置工时冲突', '最大值只能是:' + maxHours, () => {
					row.hour4day = (maxHours == 0 ? "" : maxHours)
				});
			})


		},
		//下拉名字列表选择员工
		chgEmpArres(idx2, idx) {
			let emp = this.empArres[idx][idx2]

			this.teamMember[idx].usrid = emp.id
			this.teamMember[idx].mobile = emp.mobile
			this.teamMember[idx].uid = emp.name
			this.teamMember[idx].sex = emp.sex == 1 ? '男' : '女'

			//如果是SM
			if (this.teamMember[idx].post == 'SM') {
				this.$set(this.formParameter, "header", emp.name)
			}
		},
		//打开弹框
		open(parameter, title, tid, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;


			this.tid = tid
			console.log("this.tid ", this.tid)

			this.$refs.popup.open(title, "1200px");
			this.$nextTick(() => {
				this.init();
			})
		},//选择列表的sprint后触发
		chgSprint() {
			this.sprint = this.sprintList[this.spidx]
			this.formParameter.sid = this.sprint.spid

			if (this.isAdd) {

				this.select2Use.push(true);
				this.select3Use.push(true);

				// this.teamMember.splice(0,0,{

				// 	did: this.sprint.dname,
				// 	post: "PO",
				// 	uid: this.sprint.usrnm,
				// 	usrid: this.sprint.usrid,
				// 	sex: this.sprint.sex == '1' ? "男" : "女",
				// 	mobile: this.sprint.mobile,
				// 	starttime: this.sprint.stm,
				// 	endtime: this.sprint.etm

				// });
			} else {
				//成员生效时间
				this.teamMember.forEach(v => {
					//v.starttime = 
					//v.endtime = this.sprint.etm
					this.$set(v, "starttime", this.sprint.stm)
					this.$set(v, "endtime", this.sprint.etm)
				})
				//console.log("this.teamMember",this.teamMember)
				//强制刷新数组
				//setTimeout(this.$forceUpdate(),100)

			}


		},
		//关闭弹框
		close() {
			//刷新一下页面
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				console.log("this.parameter.sid", this.parameter.sid)//  false
				console.log(this.parameter.tid)//false

				//       ture                  ture
				if (!this.parameter.sid && !this.parameter.tid) {
					//没有id的就是添加员工
					console.log("sssss");
					// let parameter = this.$utils.merger(this.formParameter);
					//将"男"转成1,"女"转换成2，uid变成了用户名字，再把uid赋值给name
					let tempteamMember = this.teamMember
					for (let i = 0; i < tempteamMember.length; i++) {
						if (tempteamMember[i].sex === '男') {
							tempteamMember[i].sex = 1;
							tempteamMember[i].name = tempteamMember[i].uid;
						} else {
							tempteamMember[i].sex = 2;
							tempteamMember[i].name = tempteamMember[i].uid;
						}
					}

					let saveTeamParam = {
						teamInfo: this.formParameter,
						teamMembers: tempteamMember,
					};
					api.saveTeam(saveTeamParam,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
					//初始化
					this.init();
				} else {
					console.log("aaaa");
					//编辑
					// let parameter = this.$utils.merger(this.formParameter);
					//将"男"转成1,"女"转换成2，uid变成了用户名字，再把uid赋值给name
					let tempteamMember = this.teamMember
					for (let i = 0; i < tempteamMember.length; i++) {
						if (tempteamMember[i].sex === '男') {
							tempteamMember[i].sex = 1;
							tempteamMember[i].name = tempteamMember[i].uid;
						} else {
							tempteamMember[i].sex = 2;
							tempteamMember[i].name = tempteamMember[i].uid;
						}
						tempteamMember[i].sid = this.parameter.sid
					}

					let updateTeamParam = {
						teamInfo: this.formParameter,
						teamMembers: tempteamMember,
						sid: this.parameter.sid,
						tid: this.parameter.tid
					};

					api.updateTeam(updateTeamParam,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);

				}
			});
		},
		init() {
			//this.popupLoading = true;
			//清除等待
			//this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			this.teamMember = [];
			//清楚校验
			//this.$refs.form.clearValidate();
			apiDpt.listAll({}, res => {
				this.deptArres = res.data
			})

			let paramx = {}
			if (this.tid) {
				paramx.tid = this.tid
			}

			//加载Sprint备选列表
			spApi.listUnTeamed(paramx, res => {
				this.sprintList = res.data
				this.spidx = ''
			})


			let parameter;
			if (this.parameter.sid) {
				parameter = { id: this.parameter.sid }
			} else {
				parameter = { tid: this.parameter.tid }
			}



			if (this.parameter) {

				api.toUpdate(parameter, response => {
					//team
					// this.popupLoading = false;
					this.formParameter.name = this.parameter.teamname;
					this.formParameter.pname = this.parameter.pname;
					this.formParameter.tid = this.tid;
					this.formParameter.header = response.data[0].header;
					//this.formParameter.id=this.parameter.tid;

					//teamMember
					for (let idx = 0; idx < response.data.length; idx++) {
						this.teamMember.push({
							id: response.data[idx].id,
							did: response.data[idx].dept,
							post: response.data[idx].post,
							uid: response.data[idx].name,
							hour4day: response.data[idx].hour4day,
							starttime: response.data[idx].starttime,
							endtime: response.data[idx].endtime,
							sex: response.data[idx].sex == 1 ? "男" : "女",
							mobile: response.data[idx].mobile,
							usrid: response.data[idx].usrid
						})
					}

				}
				);
			} else {
				//添加
				this.popupLoading = false;
			}

		},
		//添加人员
		toAddMember() {
			if (this.teamMember && this.teamMember.length > 0) {
				let first = this.teamMember[0]
				this.teamMember.push({ starttime: first.starttime, endtime: first.endtime });
			} else {
				this.teamMember.push({});
			}
		},
		//删除添加的团队成员
		delteamMember(idx) {
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				//删除,若是团队现有的成员则发请求删除，若是新添加未保存的的成员（只显示在页面还没有记录id）则从数组移除

				if (this.teamMember[idx].id) {
					let delMember = { id: this.teamMember[idx].id };
					api.delMember(delMember,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.$parent.list();
							this.teamMember.splice(idx, 1);
							this.empArres.splice(idx, 1)
							this.init();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);

				} else {
					this.teamMember.splice(idx, 1);
					//this.empArres.splice(idx, 1)
				}

			});

		},
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
